<!-- TODO(Fred): Role overrides were added to this component in order to be able to use this logic and styles in places that are not menus, ex: inside rp-mobile-pop-up -->

<ng-container *ngIf="menuItem">
  <a *ngIf="menuItem()?.routerLink; else externalLinkTemplate"
    mat-menu-item
    [role]="nonMenuItemRole() ? 'link' : 'menuitem'"
    [routerLink]="menuItem()?.routerLink"
    [queryParams]="menuItem()?.queryParams"
    [disabled]="menuItem().disabled">
    <accredible-icon *ngIf="menuItem().icon"
      class="trailing-margin"
      [icon]="menuItem().icon.name">
    </accredible-icon>
    <span>{{ menuItem().label | syncOrAsync }}</span>
  </a>

  <ng-template #externalLinkTemplate>
    <a *ngIf="menuItem()?.externalLink | syncOrAsync; else actionTemplate"
      mat-menu-item
      [role]="nonMenuItemRole() ? 'link' : 'menuitem'"
      [href]="menuItem()?.externalLink | syncOrAsync"
      [disabled]="menuItem().disabled">
      <accredible-icon *ngIf="menuItem().icon"
        class="trailing-margin"
        [icon]="menuItem().icon.name">
      </accredible-icon>
      <span>{{ menuItem().label | syncOrAsync }}</span>
    </a>
  </ng-template>

  <ng-template #actionTemplate>
    <button *ngIf="menuItem()?.actionBtn"
      mat-menu-item
      [role]="nonMenuItemRole() ? 'button' : 'menuitem'"
      (click)="menuItem()?.actionBtn(true)"
      [disabled]="menuItem().disabled">
      <accredible-icon *ngIf="menuItem().icon"
        class="trailing-margin"
        [icon]="menuItem().icon.name">
      </accredible-icon>
      <span>{{ menuItem().label | syncOrAsync }}</span>
    </button>
  </ng-template>
</ng-container>
